import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import { HISTORIC_LIST, CREATE_MODE, GENERATE_VOLUME, CREATE_HISTORIC, RESET_VOLUME } from "../actions/historicDataActions";
const historicDataReducer = (
    state = {
        historicData: [],
        historicDataLoading: false,
        createQueryMode: false,
        dataVolumeGenerated: false,
        dataVolumeGenerating: false,
        historicCreated: false,
        creatingHistoric: false,
        volumeCount: null,
    },
    action,
) => {
    switch (action.type) {
        case isPending(HISTORIC_LIST):
            return (state = {
                ...state,
                historicDataLoading: true,
                historicData: [],
            });
        case isRejected(HISTORIC_LIST):
            return (state = {
                ...state,
                historicDataLoading: false,
                historicData: [],
            });
        case isFulfilled(HISTORIC_LIST):
            return (state = {
                ...state,
                historicDataLoading: false,
                historicData: action.payload,
            });
        case CREATE_MODE:
            return (state = {
                ...state,
                createQueryMode: action.payload,
            });
        case isPending(GENERATE_VOLUME):
            return (state = {
                ...state,
                dataVolumeGenerating: true,
            });
        case isRejected(GENERATE_VOLUME):
            return (state = {
                ...state,
                dataVolumeGenerating: false,
            });
        case isFulfilled(GENERATE_VOLUME):
            return (state = {
                ...state,
                dataVolumeGenerated: true,
                dataVolumeGenerating: false,
                volumeCount: action.payload.totalPostsCount,
            });
        case isPending(CREATE_HISTORIC):
            return (state = {
                ...state,
                creatingHistoric: true,
            });
        case isRejected(CREATE_HISTORIC):
            return (state = {
                ...state,
                creatingHistoric: false,
            });
        case isFulfilled(CREATE_HISTORIC):
            return (state = {
                ...state,
                historicCreated: true,
                creatingHistoric: false,
            });
        case RESET_VOLUME:
            return (state = {
                ...state,
                dataVolumeGenerated: false,
            });

        default:
            return state;
    }
};
export default historicDataReducer;
